/**
 * Created by Ning Jiang on 11/8/2017.
 */

import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { IResizeData, StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { BarbarianFuryGameConfig } from "../BarbarianFuryGameConfig";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { ServerEvent } from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { BarbarianFuryParsedGameData } from "../server/data/BarbarianFuryParsedGameData";
import { BarbarianFuryParsedInitData } from "../server/data/BarbarianFuryParsedInitData";
import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { FreespinsCounterView, FSCounterViewData } from "./FreespinsCounterView";
import { BFGameEvent } from "../events/BFGameEvent";
import { SpinEvent } from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import { BarbarianFuryGameMode } from "../gamemode/BarbarianFuryGameMode";
import { ScalableLayer } from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { TimelineLite, TweenLite } from "gsap";
import {BarbarianFuryGameAssets} from "../BarbarianFuryGameAssets";

export class FreespinsLeftIndicator extends BaseView {

    public static readonly UPDATE_FS_NUMBER: string = "Update_Freespin_Number";
    public static readonly UPDATE_BIG_FS_COUNT: string = "Update_Big_Freespin_Number";

    private _layer: PIXI.Container;
    private _gameForeground: ScalableLayer;

    private _fsStripeObject: FreespinsCounterView;
    private _data: BarbarianFuryParsedGameData | BarbarianFuryParsedInitData;
    private _fsCount: number = 0;
    private _bigFsNum: number = 0;
    private _fsCounterBg: PIXI.Sprite;
    private _countShadow: PIXI.Sprite;
    private _furySpins: PIXI.Sprite;
    private _totalSpinCount: PIXI.BitmapText;
    private _bigCountContainer: PIXI.Container = new PIXI.Container();


    constructor() {
        super();
        this._layer = StageManager.getLayer(BarbarianFuryGameConfig.instance.LAYERS.FREESPINS_LEFT.name);
        this._gameForeground = StageManager.getLayer(BarbarianFuryGameConfig.instance.LAYERS.FOREGROUND.name);

        let nVDataObject: FSCounterViewData = {
            imageAssetPrefix: "mult_fr_",
            digits: 3,
            value: 0,
            imageLeftMargin: 0,
            imageTopMargin: 0,
            frameHeight: 100,
            frameWidth: 66,
            digitPadding: 0,
            animationDuration: 0.1,
            maskHeight: 115,
            maskWidth: 250,
            maskX: -20,
            maskY: -15
        };

        this._fsStripeObject = new FreespinsCounterView(nVDataObject);
    }

    protected addEventListeners(): void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onDataParsed(event.params[0]));
        EventHandler.addEventListener(this, FreespinsLeftIndicator.UPDATE_FS_NUMBER, (event: GameEvent) => this.updateFreespinsCounter(event.type));
        EventHandler.addEventListener(this, FreespinsLeftIndicator.UPDATE_BIG_FS_COUNT, () => this.updateBigFreespinsCounter());
        EventHandler.addEventListener(this, BFGameEvent.UPDATE_MULTIPLIER_BG, (event: GameEvent) => this.updateGraphics(event.params[0]));
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event: GameEvent) => this.updateFreespinsCounter(event.type));
    }

    protected initAnimations(): void {
        const container: PIXI.Container = new PIXI.Container();

        this._fsCounterBg = new PIXI.Sprite(GameResources.getTextures("fsCounter")[0]);
        this._fsCounterBg.anchor.set(0.5);
        this._fsStripeObject.position.set(-139, -70);
        container.addChild(this._fsCounterBg);
        container.addChild(this._fsStripeObject);
        this.addChild(container);
        this.position.set(820, 195);
        this.scale.set(0.5);
        this._layer.addChild(this);
        this._layer.visible = true;

        this._bigCountContainer = new PIXI.Container();
        let positions: [number, number] = Helper.getSymbolPositions(2, 0);
        this._totalSpinCount = new PIXI.BitmapText("0", {
            fontName: "NumbersWinCountUp",
            fontSize: 25
        });

        this._totalSpinCount.text = "0";
        this._totalSpinCount.position.set(positions[0] + 1, positions[1]);
        this._totalSpinCount.pivot.set(this._totalSpinCount.textWidth * 0.5, this._totalSpinCount.textHeight * 0.5);

        this._furySpins = new PIXI.Sprite(GameResources.getTextures("fs_fury_text")[0]);
        this._furySpins.anchor.set(0.5);
        this._furySpins.position.set(positions[0], positions[1] + BarbarianFuryGameConfig.instance.SYMBOL_HEIGHT + 20);

        this._countShadow = new PIXI.Sprite(GameResources.getTextures(BarbarianFuryGameAssets.WIN_AMOUNT_SHADOW)[0]);
        this._countShadow.anchor.set(0.5, 0.3);
        this._countShadow.scale.set(1.20, 3);
        this._countShadow.alpha = 0.5;
        this._countShadow.position.set(positions[0], positions[1]);

        this._bigCountContainer.addChild(this._countShadow, this._totalSpinCount, this._furySpins);
        this._bigCountContainer.visible = false;
        this._gameForeground.addChild(this._bigCountContainer);
    }

    protected onResize(resizeData: IResizeData): void {
        if (resizeData.orientation === "landscape") {
            this.position.set(820, 195);

            // fix for 4:3 ratio
            if (resizeData.bottom === 620 && resizeData.width <= 970) {
                this.position.set(783, 187);
            }
        } else {
            this.position.set(535, 30);
        }
    }

    private updateGraphics(src: string) {
        if (src.indexOf("bonus") > -1) {
            this.visible = true;
        } else {
            this.visible = false;
            this.updateFreespinsCounter();
        }

        this._bigFsNum = 0;
        this._bigCountContainer.visible = false;
        this._totalSpinCount.scale.set(1);
    }

    private onDataParsed(data: BarbarianFuryParsedGameData | BarbarianFuryParsedInitData): void {
        this._data = data;
    }

    private updateFreespinsCounter(event?: any): void {
        if (event === "Update_Freespin_Number") {
            this._fsCount++;
        } else if (this._data.nextMode === BarbarianFuryGameMode.STACKED_RESPIN_FREESPIN) {
            this._fsCount = this._data.freespinsLeft;
        } else {
            this._fsCount = this._data.freespinsLeft - 1;
        }

        if (this._fsCount >= 0) {
            this._fsStripeObject.setCounterValue(this._fsCount);
            this.toggleHiddenDigit(this._fsCount);
        }
    }

    private updateBigFreespinsCounter(): void {
        if (this._data.mode === BarbarianFuryGameMode.NORMAL) {
            this._bigFsNum++;

            if (!(this._bigCountContainer.visible)) {
                this._bigCountContainer.visible = true;
            }

            let positions: [number, number] = Helper.getSymbolPositions(2, 0),
                initScaling: number = 1,
                finalScaling: number = 1.5,
                scalingSteps: number = (finalScaling - initScaling) / this._data.freespinsLeft;

            const timer: TimelineLite = new TimelineLite({
                paused: true,
                onComplete: () => {
                    timer.kill();
                }
            });

            timer.add(() => {
                TweenLite.fromTo(this._totalSpinCount.scale, 0.1, {
                    x: this._totalSpinCount.scale.x,
                    y: this._totalSpinCount.scale.y
                }, {
                        x: this._totalSpinCount.scale.x + scalingSteps,
                        y: this._totalSpinCount.scale.y + scalingSteps,
                        onComplete: () => {
                            this._totalSpinCount.text = this._bigFsNum.toString();
                            this._totalSpinCount.position.set(positions[0] + 1, positions[1]);
                            if (this._totalSpinCount.text.length > 1) {
                                this._totalSpinCount.pivot.set(this._totalSpinCount.textWidth * 0.55, this._totalSpinCount.textHeight * 0.5)
                            }
                            else {
                                this._totalSpinCount.pivot.set(this._totalSpinCount.textWidth * 0.5, this._totalSpinCount.textHeight * 0.5);
                            }
                        }
                    });
            });

            timer.play();
        }
    }

    private toggleHiddenDigit(count: number): void {
        let firstHiddenDigit = Math.floor(count / 100 % 100);

        if (count > 99) {
            this._fsStripeObject._digitArr[0].container.visible = true;
            this._fsStripeObject.scale.set(0.75);
            this._fsStripeObject.position.set(-80, -65);
        } else {
            if (this._fsStripeObject._digitArr[0].container.visible) {
                this._fsStripeObject._digitArr[0].container.visible = false;
                this._fsStripeObject.scale.set(1);
                this._fsStripeObject.position.set(-139, -70);
            }
        }
    }
}